import React from "react";

export const CuposItem = React.memo((props) => {
  const quotas = props.data.Quotas
  const ciel = quotas.find(e=> e.QuotaId === 41)
  const ocup = quotas.find(e=> e.QuotaId === 2)
  const preo = quotas.find(e=> e.QuotaId === 1)
  
  const _contentBox = (opt) =>  {
    if(!opt) return "";
    const _textQuantity = (text, isRed) => {
      return <div className={isRed ? "is-red" : "is-black"}>
        {text.toString()}
      </div>
    }    
    return (<div 
      className={`item-${opt.QuotaId}`} 
      key={opt.Description + opt.QuotaId}>
        {_textQuantity(opt.QuantityQuotaScheduled, !!opt.QuantityQuotaConflict)}{"/"}{_textQuantity(opt.QuantityQuotaAvailable, !!opt.QuantityQuotaBlocked)}{" + "}{_textQuantity(opt.QuantityOverQuotaScheduled, !!opt.QuantityOverQuotaConflict)}{"/"}{_textQuantity(opt.QuantityOverQuotaAvailable, !!opt.QuantityOverQuotaBlocked)}         
    </div>)
  };
  const _ciel = _contentBox(ciel)
  const _ocup = _contentBox(ocup)
  const _preo = _contentBox(preo)
  return (<div className="cupos-appointment-item">        
    {_preo}
    {_ocup}
    {_ciel}
  </div>)
});
